export default "__VITE_ASSET__DyubAOCK__"